import { API_ORIGIN, APP_BASE_PATH } from './appBase';

export default class SimpleBIConfig {

    static KALOPSIA_URL_DEF = window.location.origin + APP_BASE_PATH;
    static KALOPSIA_API_URL_DEF = API_ORIGIN;
    
    //Base & API
    static get BASE_URL() { return this.KALOPSIA_URL_DEF };
    static get BASE_API_URL() { return this.KALOPSIA_API_URL_DEF };
    static get SIMPLEBI_URL() {return this.BASE_URL + '/'};
    static get MAIN_URL() {return this.BASE_URL +'/Main/'};
    static get API_URL() {return this.KALOPSIA_API_URL_DEF + '/api/1.0/'};
}
